export const QUESTION_FORMAT_OPTIONS = [
  { value: 'music', label: 'Мелодия' },
  { value: 'cover', label: 'Каверы' },
  { value: 'cover_arts', label: 'Обложки' },
  { value: 'artist_photo', label: 'Фото артиста' },
  { value: 'band_members', label: 'Составы групп' },
  { value: 'music_choice', label: 'Мелодия с вариантами' },
  { value: 'portmanteau_photo', label: 'Шлакоблокунь (Фото)' },
  { value: 'portmanteau_cover_art', label: 'Шлакоблокунь (Обложка)' },
  { value: 'common_word_photo', label: 'Общее слово (Фото)' },
  { value: 'common_word_cover_art', label: 'Общее слово (Обложка)' },
  { value: 'name_in_name_photo', label: 'Одно в другом (Фото)' },
  { value: 'name_in_name_cover_art', label: 'Одно в другом (Обложка)' },
  { value: 'gapoifika', label: 'ГаПоИФиКа' },
  { value: 'missing_consonants', label: 'Пропущенные согласные' },
]

export const DEFAULT_QUESTION_FORMAT = 'music'

// Форматы, доступные только через случайную (не автоматическую) тему
export const RANDOM_ONLY_FORMATS = [
  'music_choice',
  'portmanteau_photo', 'portmanteau_cover_art',
  'common_word_photo', 'common_word_cover_art',
  'name_in_name_photo', 'name_in_name_cover_art',
  'gapoifika', 'missing_consonants',
]

export function isRandomFormat(value) {
  return RANDOM_ONLY_FORMATS.includes(value)
}

export function formatLabel(value) {
  const option = QUESTION_FORMAT_OPTIONS.find(item => item.value === value)
  return option ? option.label : value
}

// Дефолт имени случайной темы
export function formatTopicPrefix(value) {
  if (value === 'music_choice') return 'Угадай мелодию: выбор'
  return formatLabel(value)
}

// Парные форматы (требуют двух артистов/фильмов)
export const PAIR_FORMATS = [
  'portmanteau_photo', 'portmanteau_cover_art',
  'common_word_photo', 'common_word_cover_art',
  'name_in_name_photo', 'name_in_name_cover_art',
]

export function isPairFormat(value) {
  return PAIR_FORMATS.includes(value)
}

// Лейбл счётчика элементов в строке кандидата
export function itemsCountLabel(format, side = null) {
  if (isPairFormat(format)) {
    if (side === 'image') {
      return format.endsWith('_photo') ? 'фото' : 'обложек'
    }
    return 'треков'
  }
  const labels = {
    cover: 'каверов',
    cover_arts: 'обложек',
    artist_photo: 'фото',
    band_members: 'составов',
  }
  return labels[format] || 'треков'
}
